import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../environments/environment';
import { catchError, tap, map } from 'rxjs/operators';
import { _throw as throwError } from 'rxjs/observable/throw';


@Injectable()
export class SystemTablesService {
	getParams: any = {};

	constructor(
		private http: HttpClient
	) {
	}

	
	getTable(tableNumber: string): Observable<any> {
		this.getParams = { TableNumber: tableNumber };
		
		console.debug('SystemTablesService getParams: ',this.getParams);

		return this.http.get<any>(environment.apiUri + '/TofesMashkanta/getSystemTable', {params: this.getParams})
			.pipe(
				map((data: any) => { // operator map for manupilate data
					data.forEach(
						obj => {
							obj.mtext = (obj.mtext).replace(String.fromCharCode(8207), '').replace(String.fromCharCode(8206), ''); //remove rtl+ltr char from text
						 });
						 return data;
						 
					}
				),
				tap( 
					data => {
						if(data && data.length > 0) {
							console.log('SystemTablesService getTable() - success');
						} else {
							this.handleErrorObservable('getTable() success; data is empty');
						}
					}
				),
				catchError(
					error => {
						 return this.handleErrorObservable(error);
					}
				)
			)
	}

	private handleErrorObservable(error: any) {
		console.debug('SystemTablesService throwError: ' + error);
		return throwError('SystemTablesService throwError: ' + error);
	}

}


// WEBPACK FOOTER //
// ./src/app/services/system-tables.service.ts